/*
 * Copyright © 2024 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {SUPPORTED_LOCALES} from '@dv/shared/code';

export async function translationLoader(locale: string): Promise<any> {
    const checkedLocale = SUPPORTED_LOCALES.check(locale);

    switch (checkedLocale) {
        case 'de-CH':
            return await import('./translations_de.json');
        case 'fr-CH':
            return await import('./translations_fr.json');
    }
}
